/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReservationShifts200ResponseMondayInner } from './GetReservationShifts200ResponseMondayInner';
import {
    GetReservationShifts200ResponseMondayInnerFromJSON,
    GetReservationShifts200ResponseMondayInnerFromJSONTyped,
    GetReservationShifts200ResponseMondayInnerToJSON,
    GetReservationShifts200ResponseMondayInnerToJSONTyped,
} from './GetReservationShifts200ResponseMondayInner';

/**
 * 
 * @export
 * @interface GetReservationShifts200Response
 */
export interface GetReservationShifts200Response {
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    monday: Array<GetReservationShifts200ResponseMondayInner>;
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    tuesday: Array<GetReservationShifts200ResponseMondayInner>;
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    wednesday: Array<GetReservationShifts200ResponseMondayInner>;
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    thursday: Array<GetReservationShifts200ResponseMondayInner>;
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    friday: Array<GetReservationShifts200ResponseMondayInner>;
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    saturday: Array<GetReservationShifts200ResponseMondayInner>;
    /**
     * 
     * @type {Array<GetReservationShifts200ResponseMondayInner>}
     * @memberof GetReservationShifts200Response
     */
    sunday: Array<GetReservationShifts200ResponseMondayInner>;
}

/**
 * Check if a given object implements the GetReservationShifts200Response interface.
 */
export function instanceOfGetReservationShifts200Response(value: object): value is GetReservationShifts200Response {
    if (!('monday' in value) || value['monday'] === undefined) return false;
    if (!('tuesday' in value) || value['tuesday'] === undefined) return false;
    if (!('wednesday' in value) || value['wednesday'] === undefined) return false;
    if (!('thursday' in value) || value['thursday'] === undefined) return false;
    if (!('friday' in value) || value['friday'] === undefined) return false;
    if (!('saturday' in value) || value['saturday'] === undefined) return false;
    if (!('sunday' in value) || value['sunday'] === undefined) return false;
    return true;
}

export function GetReservationShifts200ResponseFromJSON(json: any): GetReservationShifts200Response {
    return GetReservationShifts200ResponseFromJSONTyped(json, false);
}

export function GetReservationShifts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationShifts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'monday': ((json['monday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
        'tuesday': ((json['tuesday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
        'wednesday': ((json['wednesday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
        'thursday': ((json['thursday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
        'friday': ((json['friday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
        'saturday': ((json['saturday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
        'sunday': ((json['sunday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerFromJSON)),
    };
}

export function GetReservationShifts200ResponseToJSON(json: any): GetReservationShifts200Response {
    return GetReservationShifts200ResponseToJSONTyped(json, false);
}

export function GetReservationShifts200ResponseToJSONTyped(value?: GetReservationShifts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monday': ((value['monday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
        'tuesday': ((value['tuesday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
        'wednesday': ((value['wednesday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
        'thursday': ((value['thursday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
        'friday': ((value['friday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
        'saturday': ((value['saturday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
        'sunday': ((value['sunday'] as Array<any>).map(GetReservationShifts200ResponseMondayInnerToJSON)),
    };
}

